"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var autoBind = require("auto-bind");
var Media_1 = require("./model/data/Media");
var Environment;
(function (Environment) {
    Environment["DEVELOPMENT"] = "DEVELOPMENT";
    Environment["INTEGRATION"] = "INTEGRATION";
    Environment["PRODUCTION"] = "PRODUCTION";
})(Environment = exports.Environment || (exports.Environment = {}));
var MediaAccessStrategy;
(function (MediaAccessStrategy) {
    MediaAccessStrategy["CDN"] = "CDN";
    MediaAccessStrategy["DIRECT"] = "DIRECT";
})(MediaAccessStrategy = exports.MediaAccessStrategy || (exports.MediaAccessStrategy = {}));
var ENVIRONMENT_CONFIGURATIONS_MAP = {
    DEVELOPMENT: {
        host: "http://devel.filkers.com:8080",
        bannerPlayerUrl: "http://devel.filkers.com:2000/",
        vwUrl: "http://devel.filkers.com:2000",
        mkUrl: "http://devel.filkers.com:2000",
        mediaBaseUrl: "https://development.filkerscdn.com",
        storageBucket: "development.filkerscdn.com",
        storageRegion: "eu-central-1",
        dwPlayerProps: { noDataReloadTimeInMillis: 5000, defaultReloadTimeInMillis: 5000 }
    },
    INTEGRATION: {
        host: "https://integracion.filkers.ovxtest.com",
        bannerPlayerUrl: "https://integracion.filkers.ovxtest.com/banner/",
        vwUrl: "https://integracion.filkers.ovxtest.com/vw",
        mkUrl: "https://integracion.filkers.ovxtest.com/MediaKit",
        mediaBaseUrl: "https://integration.filkerscdn.com",
        storageBucket: "integration.filkerscdn.com",
        storageRegion: "eu-central-1",
        dwPlayerProps: { noDataReloadTimeInMillis: 5000, defaultReloadTimeInMillis: 5000 }
    },
    PRODUCTION: {
        host: "https://apirest.filkers.com",
        bannerPlayerUrl: "https://app.filkers.com/banner/",
        vwUrl: "https://vwhlp.filkers.com",
        mkUrl: "https://helpers.filkers.com/MediaKit",
        mediaBaseUrl: "https://cdn.filkers.com",
        storageBucket: "cdn.filkers.com",
        storageRegion: "eu-central-1",
        dwPlayerProps: { noDataReloadTimeInMillis: 5000, defaultReloadTimeInMillis: 60000 }
    }
};
var EnvironmentUtilsImpl = (function () {
    function EnvironmentUtilsImpl() {
        autoBind(this);
        if (process.env.REACT_APP_ENVIRONMENT !== undefined) {
            this.setEnvironment(process.env.REACT_APP_ENVIRONMENT);
        }
        else {
            this.setEnvironment(Environment.PRODUCTION);
        }
        if (process.env.REACT_APP_MEDIA_ACCESS_STRATEGY !== undefined) {
            this.setMediaAccessStrategy(process.env.REACT_APP_MEDIA_ACCESS_STRATEGY);
        }
        else {
            this.setMediaAccessStrategy(MediaAccessStrategy.CDN);
        }
        console.log("Environment " + this.environment + " initialized. Media access strategy: " + this.mediaAccessStrategy + " ");
    }
    EnvironmentUtilsImpl.prototype.getEnvironment = function () {
        return this.environment;
    };
    EnvironmentUtilsImpl.prototype.setEnvironment = function (env) {
        this.environment = env;
    };
    EnvironmentUtilsImpl.prototype.getMediaAccessStrategy = function () {
        return this.mediaAccessStrategy;
    };
    EnvironmentUtilsImpl.prototype.setMediaAccessStrategy = function (strategy) {
        this.mediaAccessStrategy = strategy;
    };
    EnvironmentUtilsImpl.prototype.getConfig = function () {
        return ENVIRONMENT_CONFIGURATIONS_MAP[this.getEnvironment()];
    };
    EnvironmentUtilsImpl.prototype.getHost = function () {
        return this.getConfig().host;
    };
    EnvironmentUtilsImpl.prototype.getBannerPlayerUrl = function () {
        return this.getConfig().bannerPlayerUrl;
    };
    EnvironmentUtilsImpl.prototype.getVirtualWindowPlayerUrl = function () {
        return this.getConfig().vwUrl;
    };
    EnvironmentUtilsImpl.prototype.getMediaKitUrl = function () {
        return this.getConfig().mkUrl;
    };
    EnvironmentUtilsImpl.prototype.getApiUrl = function () {
        return this.getHost() + "/api/app/v1";
    };
    EnvironmentUtilsImpl.prototype.getStorageBucket = function () {
        return this.getConfig().storageBucket;
    };
    EnvironmentUtilsImpl.prototype.getStorageRegion = function () {
        return this.getConfig().storageRegion;
    };
    EnvironmentUtilsImpl.prototype.getStorageUrl = function () {
        return "https://s3." + this.getStorageRegion() + ".amazonaws.com/" + this.getStorageBucket();
    };
    EnvironmentUtilsImpl.prototype.getAnimationUrl = function (template) {
        switch (this.getMediaAccessStrategy()) {
            case MediaAccessStrategy.DIRECT:
                return this.getStorageUrl() + "/" + template.animationPath;
            default:
                return this.getConfig().mediaBaseUrl + "/" + template.animationPath;
        }
    };
    EnvironmentUtilsImpl.prototype.getMediaBaseUrl = function (media) {
        if (Media_1.MediaState.EXTERNAL === media.state && media.sourceUrl !== undefined) {
            return media.sourceUrl;
        }
        else {
            switch (this.getMediaAccessStrategy()) {
                case MediaAccessStrategy.DIRECT:
                    return this.getStorageUrl() + "/" + media.path;
                default:
                    return this.getConfig().mediaBaseUrl + "/" + media.path;
            }
        }
    };
    return EnvironmentUtilsImpl;
}());
exports.EnvironmentUtils = new EnvironmentUtilsImpl();
//# sourceMappingURL=EnvironmentUtils.js.map